module.exports = __webpack_public_path__ + "static/img/code.6601f32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/code.jpg
// module id = PpiI
// module chunks = 10